import { Radio, Select } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { ReactComponent as ICON_ADD_CAMPAIGN } from "@assets/svgs/ICON_ADD_CAMPAIGN.svg";
import { ReactComponent as ICON_REMOVE_CAMPAIGN } from "@assets/svgs/ICON_REMOVE_CAMPAIGN.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const { Group: RadioGroup } = Radio;

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

const SelectDeviceContainer = styled.div`
  display: grid;
  grid-template-columns: 45% 45% auto;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
`;

const OPTION_STATUS = [
  { label: "Normal", value: "SYNCHRONIZED" },
  { label: "Synchronize", value: "SEQUENTIAL" },
];

export const FormEdit = ({
  locationId,
  customerId,
  setDataList = () => undefined,
  setIsModalVisible,
  setSelectedData,
  dataList,
  allDevices,
  deviceNotUsed,
  setDeviceNotUsed,
  campaigns,
  devices,
  selectedData,
  campaignsDuration,
}) => {
  // console.log("init deviceNotUsed :>> ", deviceNotUsed);

  // console.log("allDevices :>> ", allDevices);
  // console.log("dataList :>> ", dataList);
  // console.log("devices :>> ", devices);
  // console.log("selectedData :>> ", selectedData);

  const [isReady, setIsReady] = useState(true);
  const [selectedType, setSelectedType] = useState(_.get(selectedData, "type"));

  console.log("selectedType :>> ", selectedType);

  const defaultDeviceSelectedCampaigns = _.chain(selectedData)
    .get("deviceGroupsDetails")
    .map((item, index) => {
      return {
        device_id: _.get(item, ["device_id"]),
        index: index,
        campaignId: _.get(item, ["advertising_campaigns_id"]),
      };
    })
    .groupBy("device_id")
    .mapValues((items) => {
      return _.map(items, (item, index) => {
        return {
          index: _.get(item, ["index"]),
          campaignId: _.get(item, ["campaignId"]),
        };
      });
    })
    .value();

  const selectedDeviceGroupDetailIds = _.chain(defaultDeviceSelectedCampaigns)
    .keys()
    .map((item) => {
      return _.toInteger(item);
    })
    .value();

  const differentNotUsedDevices = _.difference(
    deviceNotUsed,
    selectedDeviceGroupDetailIds
  );
  // console.log("deviceNotUsed :>> ", deviceNotUsed);

  const defaultDeviceTypeSynchronized = _.chain(selectedData)
    .get(["deviceGroupsDetails"])
    .map((item) => {
      return _.get(item, ["device_id"]);
    })
    .uniq()
    .value();

  const defaultCampaignTypeSynchronized = _.chain(selectedData)
    .get(["deviceGroupsDetails"])
    .map((item) => {
      return _.get(item, ["advertising_campaigns_id"]);
    })
    .filter((item) => {
      return !_.isNil(item);
    })
    .uniq()
    .value();

  const defaultDeviceGroups = _.chain(selectedData)
    .get("deviceGroupsDetails", [])
    .map((item) => ({
      device: _.get(item, "device_id"),
      campaign: _.get(item, "advertising_campaigns_id"),
    }))
    .value();

  const [deviceGroups, setDeviceGroups] = useState(defaultDeviceGroups);

  const [deviceTypeSynchronized, setDeviceTypeSynchronized] = useState(
    defaultDeviceTypeSynchronized
  );
  const [campaignTypeSynchronized, setCampaignTypeSynchronized] = useState(
    defaultCampaignTypeSynchronized
  );

  const initialPreviousState = {
    deviceGroups: _.cloneDeep(defaultDeviceGroups),
    device_master: _.get(selectedData, ["device_master"]),
    deviceTypeSynchronized: _.cloneDeep(defaultDeviceTypeSynchronized),
    campaignTypeSynchronized: _.cloneDeep(defaultCampaignTypeSynchronized),
  };

  const [previousState, setPreviousState] = useState(initialPreviousState);
  console.log("initialPreviousState :>> ", initialPreviousState);

  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      name: _.get(selectedData, ["name"]),
      type: _.get(selectedData, ["type"]),
      device_master: _.get(selectedData, ["device_master"]),
      ..._.chain(selectedData)
        .get("deviceGroupsDetails", [])
        .reduce((result, item, index) => {
          const campaignId = _.get(item, "advertising_campaigns_id");
          return {
            ...result,
            [`device-${index}`]: _.get(item, "device_id"),
            [`campaign-${index}`]: _.find(campaigns, (campaignItem) => {
              return _.get(campaignItem, ["value"]) === campaignId;
            }),
          };
        }, {})
        .value(),
    },
  });
  const watchSelectedType = watch("type");
  const watchDeviceMaster = watch("device_master");

  const onHandleEdit = async (data) => {
    console.log("data :>> ", data);
    const deviceGroupsDetailsTypeSequential = _.map(deviceGroups, (group) => ({
      device_id: group.device,
      advertising_campaigns_id: group.campaign,
    }));
    console.log(
      "deviceGroupsDetailsTypeSequential :>> ",
      deviceGroupsDetailsTypeSequential
    );

    console.log("deviceTypeSynchronized :>> ", deviceTypeSynchronized);
    console.log("campaignTypeSynchronized :>> ", campaignTypeSynchronized);
    const deviceGroupsDetailsTypeSynchronized = _.flatMap(
      deviceTypeSynchronized,
      (device) => {
        return _.map(campaignTypeSynchronized, (campaign) => ({
          device_id: device,
          advertising_campaigns_id: campaign,
        }));
      }
    );

    const id = _.get(selectedData, ["id"]);
    const name = _.get(data, ["name"]);
    const offset = 0;
    const device_master = _.get(data, ["device_master"]);
    const type = _.get(data, ["type"]);

    const aaa = {
      id,
      name,
      offset,
      type,
      location_id: locationId,
      customer_id: customerId,
      device_master:
        type === "SEQUENTIAL"
          ? device_master
          : _.get(deviceTypeSynchronized, [0], null),
      deviceGroupsDetails:
        type === "SEQUENTIAL"
          ? deviceGroupsDetailsTypeSequential
          : deviceGroupsDetailsTypeSynchronized,
    };

    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/device-groups/update",
      isAuth: true,
      data: {
        id,
        name,
        offset,
        type,
        location_id: locationId,
        customer_id: customerId,
        device_master:
          type === "SEQUENTIAL"
            ? device_master
            : _.get(deviceTypeSynchronized, [0], null),
        deviceGroupsDetails:
          type === "SEQUENTIAL"
            ? deviceGroupsDetailsTypeSequential
            : deviceGroupsDetailsTypeSynchronized,
      },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();

      // const updateDeviceNotUsed = _.uniq([
      //   ..._.map(results.deviceGroupsDetails, "device_id"),
      //   ...deviceNotUsed,
      // ]);

      const deviceUsed = _.chain(results)
        .get(["deviceUsed"])
        .map((item) => {
          return _.get(item, ["device_id"]);
        })
        .uniq()
        .value();
      // console.log("init deviceNotUsed :>> ", deviceNotUsed);
      // console.log("updateDeviceNotUsed :>> ", updateDeviceNotUsed);
      // console.log("2 = D(1)");
      // console.log("6 = Office");
      // console.log("7 = D(2)");
      // console.log("8 = D(3)");
      // console.log("9 = D(4)");

      setDeviceNotUsed(deviceUsed);
      const deviceGroup = _.get(results, ["deviceGroup"]);
      toast.success("Update Group Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      setSelectedData(null);
      setDataList((prev) =>
        _.map(prev, (item) =>
          _.get(item, ["id"]) === id ? { ...item, ...deviceGroup } : item
        )
      );
    }
  };

  //

  const handleCampaignChange = ({ campaignId, index }) => {
    const updatedDeviceGroups = _.map(deviceGroups, (group, i) =>
      i === index ? { ...group, campaign: campaignId } : group
    );

    const autoMasterDeviceId = _.chain(updatedDeviceGroups)
      .groupBy("device")
      .mapValues((group) => {
        return _.sumBy(group, (item) => {
          // console.log("item :>> ", item);
          const campaign = _.get(item, ["campaign"]);
          const duration = _.get(campaignsDuration, [campaign]);
          return duration;
        });
      })
      .toPairs()
      .minBy(([device, duration]) => duration)
      .head()
      .toInteger()
      .value();
    //
    setValue("device_master", autoMasterDeviceId);
    setDeviceGroups(updatedDeviceGroups);
  };

  const getAvailableCampaigns = ({ index }) => {
    // const deviceId = deviceGroups[index].device;
    const deviceId = _.get(deviceGroups, [index, "device"]);
    const deviceCampaignMap = _.reduce(
      deviceGroups,
      (result, group, idx) => {
        if (group.device && group.campaign) {
          result[group.device] = result[group.device] || [];
          result[group.device].push(group.campaign);
        }
        return result;
      },
      {}
    );

    const usedCampaigns = _.get(deviceCampaignMap, [deviceId], []);

    const result = _.filter(campaigns, (item) => {
      const campaignValue = _.get(item, "value");
      return !_.includes(usedCampaigns, campaignValue);
    });

    return result;
  };

  const getAvailableCampaignsTypeSynchronized = () => {
    const result = _.filter(campaigns, (item) => {
      const campaignValue = _.get(item, "value");
      return !_.includes(campaignTypeSynchronized, campaignValue);
    });

    return result;
  };

  const getDeviceMaster = () => {
    const selectedDevices = _.map(deviceGroups, (group) => group.device);
    return _.filter(allDevices, (device) =>
      _.includes(selectedDevices, device.value)
    );
  };

  const getAvailableDevices = () => {
    const filterDevices = _.filter(allDevices, (item) => {
      const value = _.get(item, ["value"]);
      return !_.includes(differentNotUsedDevices, value);
    });
    return filterDevices;
  };

  const onHandleDeleteDevice = ({ index }) => {
    const updatedDeviceGroups = _.filter(
      deviceGroups,
      (group, i) => i !== index
    );

    const autoMasterDeviceId = _.chain(updatedDeviceGroups)
      .groupBy("device")
      .mapValues((group) => {
        return _.sumBy(group, (item) => {
          // console.log("item :>> ", item);
          const campaign = _.get(item, ["campaign"]);
          const duration = _.get(campaignsDuration, [campaign]);
          return duration;
        });
      })
      .toPairs()
      .minBy(([device, duration]) => duration)
      .head()
      .toInteger()
      .value();

    setValue("device_master", autoMasterDeviceId);
    setDeviceGroups(updatedDeviceGroups);
  };

  const handleDeviceChangeTypeSynchronized = ({ value }) => {
    setDeviceTypeSynchronized(value);
  };

  const handleCampaignChangeTypeSynchronized = ({ value, index }) => {
    console.log("{ value, index } :>> ", { value, index });

    setCampaignTypeSynchronized((prev) => {
      const updateData = [...prev];
      _.set(updateData, [index], value);
      return updateData;
    });
  };

  const onDeleteCampaignChangeTypeSynchronized = ({ index }) => {
    setCampaignTypeSynchronized((prev) => {
      const updateData = _.chain(prev)
        .cloneDeep()
        .filter((data, dataIndex) => {
          return index !== dataIndex;
        })
        .tap((data) => console.log("data", data))
        .value();
      return updateData;
    });
  };

  useEffect(() => {
    if (watchSelectedType !== selectedData?.type) {
      setDeviceGroups([]);
      setValue("device_master", null);
      setDeviceTypeSynchronized([]);
      setCampaignTypeSynchronized([]);
    } else {
      setDeviceGroups(previousState?.deviceGroups);
      setValue("device_master", previousState?.device_master);
      setDeviceTypeSynchronized(previousState?.deviceTypeSynchronized);
      setCampaignTypeSynchronized(previousState?.campaignTypeSynchronized);
    }

    setIsReady(true);
  }, [watchSelectedType]);

  useEffect(() => {
    if (
      watchSelectedType === "SYNCHRONIZED" &&
      watchDeviceMaster &&
      !_.includes(deviceTypeSynchronized, watchDeviceMaster)
    ) {
      setValue("device_master", null);
    }
  }, [deviceTypeSynchronized, watchDeviceMaster, setValue]);

  return (
    <FormContainer onSubmit={handleSubmit(onHandleEdit)} autoComplete="off">
      <Line />
      <InnerContainer style={{ overflow: "scroll", gap: 8 }}>
        <div>
          <Controller
            name="name"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Name
                </Text>
                <StyledInput
                  label="name"
                  {...field}
                  size="large"
                  placeholder="name"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          {watchSelectedType === "SEQUENTIAL" && (
            <Controller
              name={`device_master`}
              control={control}
              rules={_.get(VALIDATE_RULES, ["required"])}
              render={({ field, fieldState: { error } }) => (
                <div style={{ flex: 1 }}>
                  <Text
                    color={COLOR_DARK}
                    fontSize="14px"
                    style={{ marginBottom: 4, marginLeft: 4 }}
                  >
                    Device Master
                  </Text>
                  <Select
                    {...field}
                    size="large"
                    showSearch
                    placeholder="Select a device master"
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    disabled={_.isEmpty(getDeviceMaster())}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={getDeviceMaster()}
                    // onChange={(selected) => {
                    //   field.onChange(selected.value);
                    // }}
                  />
                  <ErrorValidate justify="start" error={error} />
                </div>
              )}
            />
          )}

          <Controller
            name="type"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Type
                </Text>
                <RadioGroup
                  {...field}
                  options={OPTION_STATUS}
                  optionType="button"
                  style={{
                    borderColor: error ? "red" : undefined,
                  }}
                  onChange={(e) => {
                    setIsReady(false);
                    field.onChange(e.target.value);
                    setSelectedType(e.target.value);
                  }}
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
          {watchSelectedType === "SYNCHRONIZED" && isReady && (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div style={{ flex: 1 }}>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Device
                </Text>
                <Select
                  size="large"
                  mode="multiple"
                  showSearch
                  placeholder="Select a device"
                  optionFilterProp="children"
                  style={{ flex: 1, width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={getAvailableDevices()}
                  value={deviceTypeSynchronized}
                  onChange={(value) => {
                    handleDeviceChangeTypeSynchronized({ value });
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <Text
                    color={COLOR_DARK}
                    fontSize="14px"
                    style={{ marginBottom: 4, marginLeft: 4 }}
                  >
                    Campaign
                  </Text>
                  <ICON_ADD_CAMPAIGN
                    style={{ cursor: "pointer" }}
                    // onClick={() => console.log("add campaign :>> ")}
                    onClick={() =>
                      setCampaignTypeSynchronized((prev) => [...prev, null])
                    }
                  />
                </div>
                {/* setCampaignTypeSynchronized */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                >
                  {_.map(campaignTypeSynchronized, (campaignId, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 8,
                          alignItems: "center",
                        }}
                      >
                        <Select
                          size="large"
                          showSearch
                          placeholder="Select a campaign"
                          optionFilterProp="children"
                          style={{ flex: 1, width: "100%" }}
                          filterOption={(input, option) =>
                            (option?.label ?? "").includes(input)
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? "")
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? "").toLowerCase()
                              )
                          }
                          options={getAvailableCampaignsTypeSynchronized()}
                          // value={group.campaign}
                          value={_.chain(campaigns)
                            .find((item) => {
                              return _.get(item, ["value"]) === campaignId;
                            })
                            .get(["label"])
                            .value()}
                          onChange={(value) =>
                            handleCampaignChangeTypeSynchronized({
                              value,
                              index,
                            })
                          }
                        />

                        <ICON_REMOVE_CAMPAIGN
                          onClick={() =>
                            onDeleteCampaignChangeTypeSynchronized({ index })
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {watchSelectedType === "SEQUENTIAL" && isReady && (
            <>
              {_.map(deviceGroups, (group, index) => (
                <SelectDeviceContainer key={index}>
                  <div style={{ flex: 1 }}>
                    <Text
                      color={COLOR_DARK}
                      fontSize="14px"
                      style={{ marginBottom: 4, marginLeft: 4 }}
                    >
                      Device
                    </Text>
                    <Select
                      size="large"
                      showSearch
                      placeholder="Select a device"
                      optionFilterProp="children"
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={getAvailableDevices()}
                      value={group.device}
                      onChange={(value) => {
                        const updatedDeviceGroups = _.map(
                          deviceGroups,
                          (grp, i) =>
                            i === index
                              ? { ...grp, device: value, campaign: null }
                              : grp
                        );
                        setDeviceGroups(updatedDeviceGroups);
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Text
                      color={COLOR_DARK}
                      fontSize="14px"
                      style={{ marginBottom: 4, marginLeft: 4 }}
                    >
                      Campaign
                    </Text>
                    <Select
                      size="large"
                      showSearch
                      placeholder="Select a campaign"
                      optionFilterProp="children"
                      style={{ flex: 1, width: "100%" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={getAvailableCampaigns({ index })}
                      // value={group.campaign}
                      value={_.chain(campaigns)
                        .find((item) => {
                          return (
                            _.get(item, ["value"]) ===
                            _.get(group, ["campaign"])
                          );
                        })
                        .get(["label"])
                        .value()}
                      disabled={!group.device}
                      onChange={(value) =>
                        handleCampaignChange({ campaignId: value, index })
                      }
                    />
                  </div>
                  <Icon
                    disabled={index === 0}
                    style={{ marginTop: 30 }}
                    isCursor
                    width={34}
                    height={34}
                    onClick={() => onHandleDeleteDevice({ index })}
                  >
                    <ICON_TABLE_DELETE />
                  </Icon>
                </SelectDeviceContainer>
              ))}
              <ButtonContainer style={{ justifyContent: "end" }}>
                <Button
                  style={{ marginTop: 2 }}
                  type="button"
                  color={COLOR_GREEN}
                  fontColor={COLOR_WHITE}
                  fontSize="16px"
                  padding="5px 20px"
                  // onClick={() => setGroupDetailsLength((prev) => prev + 1)}
                  onClick={() =>
                    setDeviceGroups((prev) => [
                      ...prev,
                      { device: null, campaign: null },
                    ])
                  }
                >
                  Add DeviceInGroups
                </Button>
              </ButtonContainer>
            </>
          )}
        </div>

        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
